import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { OnboardingProvider } from "../context/OnboardingContext";
import Loader from "../components/Loader/Loader";
const Users = lazy(() => import("../pages/Dashboard/Users/Users"));
const Meals = lazy(() => import("../pages/Dashboard/Meals/Meals"));
const Exercises = lazy(() => import("../pages/Dashboard/Exercises/Exercises"));
const Workouts = lazy(() => import("../pages/Dashboard/Workouts/Workouts"));
const Routines = lazy(() => import("../pages/Dashboard/Routines/Routines"));
const Landing = lazy(() => import("../pages/Landing/Landing"));
const Login = lazy(() => import("../pages/Login"));
const UserProfile = lazy(() =>
  import("../pages/Dashboard/Users/UserProfile/UserProfile")
);
const Analytics = lazy(() => import("../pages/Dashboard/Analytics/Analytics"));
const Logout = lazy(() => import("../pages/Dashboard/Logout/Logout"));
const ProtectedRoute = lazy(() => import("./ProtectedRoute"));
const Notifications = lazy(() =>
  import("../pages/Dashboard/Notifications/Notifications")
);
const SettingsManagement = lazy(() =>
  import("../pages/Dashboard/Settings/SettingsManagement")
);
const SourcePage = lazy(() =>
  import("../pages/Dashboard/SourcePage/SourcePage")
);

const CreateAccount = lazy(() => import("../pages/onBording/CreateAccount"));
const Step1 = lazy(() => import("../pages/onBording/OnBordingSteps/Step1"));
const Step2 = lazy(() => import("../pages/onBording/OnBordingSteps/Step2"));
const Step3 = lazy(() => import("../pages/onBording/OnBordingSteps/Step3"));
const Step4 = lazy(() => import("../pages/onBording/OnBordingSteps/Step4"));
const Step5 = lazy(() => import("../pages/onBording/OnBordingSteps/Step5"));
const Step6 = lazy(() => import("../pages/onBording/OnBordingSteps/Step6"));
const Step7 = lazy(() => import("../pages/onBording/OnBordingSteps/Step7"));
const Step8 = lazy(() => import("../pages/onBording/OnBordingSteps/Step8"));
const Step9 = lazy(() => import("../pages/onBording/OnBordingSteps/Step9"));
const Step10 = lazy(() => import("../pages/onBording/OnBordingSteps/Step10"));
const Step11 = lazy(() => import("../pages/onBording/OnBordingSteps/Step11"));
const Step12 = lazy(() => import("../pages/onBording/OnBordingSteps/Step12"));
const Resultes = lazy(() => import("../pages/onBording/Resultes/Resultes"));
const OnBordingProtectedRoute = lazy(() => import("./OnBordingProtectedRoute"));

const Routers = () => {
  return (
    <OnboardingProvider>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="login" element={<Login />} />
          <Route
            path="onbording"
            element={<Navigate to="/onbording/create" />}
          />
          <Route
            path="onbording/create"
            element={
              <onBording>
                <CreateAccount />
              </onBording>
            }
          />

          <Route
            path="onbording/*"
            element={
              <Suspense
                fallback={
                  <div className="flex justify-center items-center bg-[#151515] h-screen font-bold text-xl text-white text-center">
                    Loading next step...
                  </div>
                }
              >
                <OnBordingProtectedRoute>
                  <Routes>
                    <Route path="step1" element={<Step1 />} />
                    <Route path="step2" element={<Step2 />} />
                    <Route path="step3" element={<Step3 />} />
                    <Route path="step4" element={<Step4 />} />
                    <Route path="step5" element={<Step5 />} />
                    <Route path="step6" element={<Step6 />} />
                    <Route path="step7" element={<Step7 />} />
                    <Route path="step8" element={<Step8 />} />
                    <Route path="step9" element={<Step9 />} />
                    <Route path="step10" element={<Step10 />} />
                    <Route path="step11" element={<Step11 />} />
                    <Route path="step12" element={<Step12 />} />
                    <Route path="resultes" element={<Resultes />} />
                  </Routes>
                </OnBordingProtectedRoute>
              </Suspense>
            }
          ></Route>

          <Route path="*" element={<Navigate to="/" />} />

          <Route
            path="dashboard"
            element={<Navigate to="/dashboard/analytics" />}
          />

          <Route
            path="dashboard/*"
            element={
              <ProtectedRoute>
                <Routes>
                  <Route path="analytics" element={<Analytics />} />
                  <Route path="users" element={<Users />} />
                  <Route path="users/:id" element={<UserProfile />} />
                  <Route path="meals" element={<Meals />} />
                  <Route path="exercises" element={<Exercises />} />
                  <Route path="workouts" element={<Workouts />} />
                  <Route path="routines" element={<Routines />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route
                    path="plan-management"
                    element={<SettingsManagement />}
                  />
                  <Route path="source" element={<SourcePage />} />
                  <Route path="logout" element={<Logout />} />
                  <Route path="*" element={<Navigate to="analytics" />} />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </OnboardingProvider>
  );
};

export default Routers;
